import clsx from 'clsx';

import React, { useState } from 'react';
import CDF from '../Sections/CDF';
import TOC from '../TOC';
import HelpfulGuides from '../Sections/HelpfulGuides';

import { ReactComponent as ChevronDown } from './../../public/images/chevron-down.svg';
import { ReactComponent as ChevronUp } from './../../public/images/chevron-up.svg';

const Sidebar = ({ headings, data, allChildArticles }) => {
  const [isGuidesCollapsed, setIsGuidesCollapsed] = useState(true);
  const classes = clsx('sidebar', {
    'sidebar--guides-collapsed': isGuidesCollapsed,
  });
  const { pageBy } = data;
  const { articleBy } = data;
  const { sections, banner, template } = pageBy || articleBy;
  const { sections: pageSections } = sections;

  const sidebarSubPages = allChildArticles?.data.siteTopics?.nodes[0];
  const showSubPages = sidebarSubPages?.siteTopicsInfo?.showSidebar;
  const subPagesTitle = sidebarSubPages?.siteTopicsInfo?.sidebarTitle;
  const subPagesList = sidebarSubPages?.articles?.nodes;

  let showPopup = false;
  if (data.articleBy && banner?.displayOption !== 'enable') {
    showPopup = true;
  }
  if (data.pageBy && template?.banner?.displayOption !== 'enable') {
    showPopup = true;
  }
  const guidesOpt = pageSections.find(
    (section) =>
      section.fieldGroupName === 'Page_Sections_Sections_HelpfulGuides' ||
      section.fieldGroupName === 'Article_Sections_Sections_HelpfulGuides',
  );
  const { guides } = guidesOpt || '';

  const handleToggleCollapseGuides = () => {
    setIsGuidesCollapsed(!isGuidesCollapsed);
  };

  return (
    <aside className={classes}>
      {showSubPages && subPagesList?.length > 0 && (
        <div className="sidebar__helpful-guides sidebar__subpage__list">
          <div className="sidebar__helpful-guides__title">
            <strong onClick={handleToggleCollapseGuides}>
              {subPagesTitle || 'Related pages'}
            </strong>
          </div>
          <div className="section__helpful-guides">
            <h3>{subPagesTitle || 'Related pages'}</h3>
            <div>
              <ul>
                {subPagesList?.map((guide) => {
                  return (
                    <li>
                      <a href={guide.uri}>{guide.title}</a>
                    </li>
                  );
                })}
              </ul>
            </div>
          </div>
        </div> 
      )}
      {!!headings?.length && <TOC headings={headings} isDefaultUncollapsed={false} />}

      {guides?.length > 0 && (
        <div className="sidebar__helpful-guides">
          <div className="sidebar__helpful-guides__title">
            <strong onClick={handleToggleCollapseGuides}>
              Our related guides
              {!isGuidesCollapsed ? <ChevronDown /> : <ChevronUp />}
            </strong>
          </div>
          {isGuidesCollapsed && <HelpfulGuides guides={guides} sideBar="yes" />}
        </div>
      )}
      {showPopup ? (
        <section className="sidebar__grapple-new">
          <div className="sidebar__grapple-new">
            <img
              className="sidebar__grapple-new__image"
              src="/images/popup-logo.png"
              width="127px"
              height="56px"
            />
            <h4 className="sidebar__grapple-new__info">Do I Have a Case?</h4>
            <h6 className="sidebar__grapple-new__text">Free Instant Assessment</h6>
            <a className="sidebar__grapple-new__button button" href="/do-i-have-a-case">
              Get Started
            </a>
          </div>
        </section>
      ) : (
        <></>
      )}
      <div className="sidebar__cdf">
        <CDF sideBar={true} contactFieldLayout={true} />
      </div>
    </aside>
  );
};

export default Sidebar;
